import { render, staticRenderFns } from "./ReportPegaPlantoesSyncLogs.vue?vue&type=template&id=333d2e5b&"
import script from "./ReportPegaPlantoesSyncLogs.vue?vue&type=script&lang=js&"
export * from "./ReportPegaPlantoesSyncLogs.vue?vue&type=script&lang=js&"
import style0 from "./ReportPegaPlantoesSyncLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports